import DefineAssignment from './define-assignment.view';

export default DefineAssignment;
